import React from "react";
import { T } from "../theme";

// `rateCard` module — the published hourly rates. The module's monthly
// presence (ad-hoc line items priced off these rates) renders inside
// MonthlyLedger; this card is the reference list, shown only when rates
// exist.
export default function RateCardCard({ rates }) {
  if (!rates || rates.length === 0) return null;
  return (
    <div style={{ marginTop: 24, marginBottom: 40, background: T.canvas, borderRadius: T.radiusMd, border: `1px solid ${T.borderSubtle}`, padding: "20px 24px", boxShadow: T.shadowSm }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, color: T.root, marginBottom: 12 }}>Rate card</h3>
      {rates.map((r, i) => (
        <div key={r.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: i < rates.length - 1 ? `1px solid ${T.borderSubtle}` : "none" }}>
          <span style={{ fontSize: 13, color: T.root }}>{r.label}</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: T.root }}>${r.rate}{r.unit || "/hr"}</span>
        </div>
      ))}
    </div>
  );
}
